# GraphQL mutation to update a slack automation
#import "../fragments/sales-automation-stageset.graphql"

mutation UpdateClosedLeadSlackMessage(
    $closedLeadSlackMessage: UpdateClosedLeadSlackMessageInputFieldInput!
) {
    updateClosedLeadSlackMessage(input: {closedLeadSlackMessage: $closedLeadSlackMessage}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
